import React, { useState } from 'react';
import './Donate.css';
import { Link } from 'react-router-dom';


const Donate = () => {
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [customAmount, setCustomAmount] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    donationType: 'one-time',
    message: ''
  });

  const donationAmounts = [5, 10, 20, 30, 40, 50, 100, 200, 1000];

  const handleAmountSelect = (amount) => {
    setSelectedAmount(amount);
    setCustomAmount('');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCustomAmountChange = (e) => {
    const value = e.target.value;
    setCustomAmount(value);
    setSelectedAmount(null);
  };

  const handleDonate = (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email) {
      alert('Please fill in all required fields.');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Please enter a valid email address.');
      return;
    }
    
    const amount = selectedAmount || customAmount;
    if (!amount || amount <= 0) {
      alert('Please select or enter a donation amount.');
      return;
    }
    
    alert(`Thank you for your donation of $${amount}! This would redirect to our payement provider!`);
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      donationType: 'one-time',
      message: ''
    });
    setSelectedAmount(null);
    setCustomAmount('');
  };

  const impactAreas = [
    {
      icon: 'fas fa-graduation-cap',
      title: 'Knowlege Sharing',
      description: 'Support and knowledge sharing and educational resources for software engineers.'
    },
    {
      icon: 'fas fa-users',
      title: 'Public Advocacy',
      description: 'Help eductate the public  on the importance of American engineering talent.'
    },
    {
      icon: 'fas fa-laptop-code',
      title: 'Research & Innovation',
      description: 'Fund cutting-edge research and innovation in software engineering practices.'
    },
    {
      icon: 'fas fa-calendar-alt',
      title: 'Events & Conferences',
      description: 'Sponsor conferences, meetups, and networking events for our community.'
    },
    {
      icon: 'fas fa-book',
      title: 'Resources & Articles',
      description: 'Maintain and expand our resource library and online learning platforms.'
    },
    {
      icon: 'fas fa-heart',
      title: 'Program Support',
      description: 'Support our general operations and help us continue our mission.'
    }
  ];

  const testimonials = [
    {
      content: "I've been a monthly donor for three years. Knowing that my contributions help support education and diversity in software engineering makes it all worthwhile.",
      author: "JM",
      role: "Senior Developer, TechSolutions"
    },
    {
      content: "The impact of this organization on students and professionals is incredible. I'm proud to support their mission through regular donations.",
      author: "DK",
      role: "CTO, InnovateLab"
    },
    {
      content: "As a former scholarship recipient, I now donate to help others have the same opportunities I had. It's a way to give back to the community.",
      author: "MR",
      role: "Software Engineer, CloudTech"
    }
  ];

  return (
    <div className="donate-page">
      <div className="donate-hero">
        <div className="container">
          <h1>Support Our Mission</h1>
          <p>Your donation helps us advance software engineering excellence through education, networking, and innovation</p>
        </div>
      </div>

      <div className="container">
        <section className="donate-impact">
          <h2 className="section-title">How Your Donation Makes a Difference</h2>
          <p className="impact-subtitle">Your generous contribution supports our programs and initiatives that benefit software engineers across the country</p>
          <div className="impact-grid">
            {impactAreas.map((area, index) => (
              <div key={index} className="impact-card">
                <div className="impact-icon">
                  <i className={area.icon}></i>
                </div>
                <h3>{area.title}</h3>
                <p>{area.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="donate-form-section">
          <div className="donate-form-container">
            <div className="donate-info">
              <h2>Make a Donation</h2>
              <p>Every contribution, no matter the size, helps us continue our important work in the software engineering community.</p>
            </div>

            <div className="donate-form">
              <form onSubmit={handleDonate}>
                <div className="donation-amounts">
                  <h3>Select Amount</h3>
                  <div className="amount-buttons">
                    {donationAmounts.map((amount) => (
                      <button
                        key={amount}
                        type="button"
                        className={`amount-btn ${selectedAmount === amount ? 'selected' : ''}`}
                        onClick={() => handleAmountSelect(amount)}
                      >
                        ${amount}
                      </button>
                    ))}
                  </div>
                  <div className="custom-amount">
                    <label htmlFor="customAmount">Or enter custom amount</label>
                    <div className="custom-amount-input">
                      <span className="currency-symbol">$</span>
                      <input
                        type="number"
                        id="customAmount"
                        name="customAmount"
                        value={customAmount}
                        onChange={handleCustomAmountChange}
                        placeholder="0.00"
                        min="1"
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="donationType">Donation Type *</label>
                  <select
                    id="donationType"
                    name="donationType"
                    value={formData.donationType}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="one-time">One-time Donation</option>
                    <option value="monthly">Monthly Recurring</option>
                    <option value="annual">Annual Recurring</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message (Optional)</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="3"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Add a personal message with your donation..."
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary btn-donate">
                  Donate Now
                </button>
              </form>
            </div>
          </div>
        </section>

        <section className="donate-cta">
          <div className="cta-content">
            <h2>Other Ways to Support</h2>
            <p>Donations are just one way to support our mission. You can also message us to get involved and help out.</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-outline">Contact Us</Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Donate;

